




















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IDateDurationExpressionBehavior, DateDurationKinds, ILinkedObjectSpecifiable } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { FormatObjectSelectorColumnTypes } from "../../../../../formatEditor/components/format/editors/contents/commonComponents/selectors";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";
import { DateObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class DateDurationExpressionBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (write: (source: IDateDurationExpressionBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDateDurationExpressionBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get kind(): DateDurationKinds {
    return this.readPropertyOrDefault(s => s.kind, DateDurationKinds.Days);
  }

  set kind(value: DateDurationKinds) {
    this.writePropertyWhenValid(s => s.kind = value);
  }

  get isContainedFrom(): boolean {
    return this.readPropertyOrDefault(s => s.isContainedFrom, true);
  }

  set isContainedFrom(value: boolean) {
    this.writePropertyWhenValid(s => s.isContainedFrom = value);
  }

  get isEnable(): boolean {
    return this.kind === DateDurationKinds.Days || this.kind === DateDurationKinds.Weeks;
  }

  get from(): ILinkedObjectSpecifiable {
    return this.readPropertyOrDefault(s => s.from, null);
  }

  get to(): ILinkedObjectSpecifiable {
    return this.readPropertyOrDefault(s => s.to, null);
  }

  get selectionObjects(): ILinkedObjectSpecifiable[] {
    return Enumerable.from(this.commonComponents.currentPage.getObjects())
      .select(o => o instanceof DateObjectEditor ? o : null)
      .where(o => !!o && o.isDate().getValue())
      .select(o => o.toLinkedObjectIdentifier())
      .where(o => !!o.key)
      .toArray();
  }

  async showDateDurationEditDialog() {
    const dialog = this.commonComponents.getDialogs().getDateDurationSelectDialog();
    const range = await dialog.show({
      from: this.from,
      to: this.to,
      selectionObjects: this.selectionObjects,
      dialogTitle: "期間日数項目編集",
      fromTitle: "開始日",
      toTitle: "終了日",
      toCellString: this.toCellString,
    });
    if (!range) { return; }
    this.writePropertyWhenValid(s => {
      s.from = range.from;
      s.to = range.to;
    });
  }

  private toCellString(column: FormatObjectSelectorColumnTypes, row: ILinkedObjectSpecifiable): string {
    const formatObject = this.getFormatObjectEditable(row);
    switch (column) {
      case "key":
        return formatObject && formatObject.getIdentifiableName()
          ? formatObject.getIdentifiableName()
          : row.key;
      case "id":
        return row.id ? row.id.toString() : "";
      default:
        return "";
    }
  }

  private getFormatObjectEditable(row: ILinkedObjectSpecifiable): IFormatObjectEditable {
    return Enumerable.from(this.commonComponents.currentPage.getObjects())
      .firstOrDefault(o => {
        const linkedObject = o.toLinkedObjectIdentifier();
        return linkedObject.type === row.type &&
          linkedObject.id === row.id &&
          linkedObject.key === row.key &&
          linkedObject.isDate === row.isDate;
      });
  }

  kindOptions: StandardOption<DateDurationKinds>[] = [
    new StandardOption<DateDurationKinds>("日数", DateDurationKinds.Days),
    new StandardOption<DateDurationKinds>("週数", DateDurationKinds.Weeks),
    new StandardOption<DateDurationKinds>("年数(単位なし)", DateDurationKinds.Years),
    new StandardOption<DateDurationKinds>("年齢(月日)", DateDurationKinds.Age),
  ];
}
